import { useSelector } from "react-redux";
import { includes } from "lodash";
import { getActiveOrgUnitIds, getSignedInOrgUnit } from "../app/auth/store/reducers/user.reducer";

// This hook checks whether the user is stuck on a signed-in site.
// What is the stuck state?
//   The stuck state occurs when a user is signed in to a site where they have no role, or the signed-in site is deprecated,
//   but they have roles on other sites.
const useIsUserStuckInSignedInSite = () => {
  const sitesWhereUserHasRole = useSelector(getActiveOrgUnitIds);
  const signedInSite = useSelector(getSignedInOrgUnit);

  // if the user has roles on sites other than the signed-in site,
  // then they are stuck
  return !includes(sitesWhereUserHasRole, signedInSite.id);
};

export default useIsUserStuckInSignedInSite;
